// Interruptor para ver el banner en cualquier búsqueda mientras se ajusta el diseño.
// En true ignora país, filtros y ubicación, así que el banner deja de ocultarse: dejar
// en false salvo que se esté trabajando sobre el diseño.
export const FORCE_SHOW_BANNER = false;

// UUID de la location en producción, verificado contra routeChecker y contra el
// payload del search-service. No se asume estable entre entornos: si en dev o beta
// el id fuera otro, el match por nombre de abajo sigue cubriendo el caso.
export const PUNTA_DEL_ESTE_LOCATION_ID: number | string | null =
	"89049a8e-eb92-465c-bd44-830fa12c3ccb";

const PUNTA_DEL_ESTE_NAME = "punta del este";
const COUNTRY = "UY";

const normalize = (value?: string | null) => {
	if (!value) return "";
	return value
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.replace(/\s+/g, " ")
		.trim();
};

const toArray = value => {
	if (!value) return [];
	return Array.isArray(value) ? value : [value];
};

// Alcanza con que coincida el id o el nombre. El id cubre un cambio de nombre desde
// el backend; el nombre cubre un entorno donde el id sea otro. Dentro de Uruguay
// —único país donde esto corre— "Punta del Este" no es ambiguo, así que el match por
// nombre no genera falsos positivos.
const isPuntaDelEste = (item, locationId) => {
	if (!item) return false;
	if (locationId != null && String(item.id) === String(locationId)) return true;
	return normalize(item.name).includes(PUNTA_DEL_ESTE_NAME);
};

export const shouldShowPuntaDelEsteBanner = ({
	country_code,
	filters,
	filtersTags,
	locationId = PUNTA_DEL_ESTE_LOCATION_ID,
	forceShow = FORCE_SHOW_BANNER,
}): boolean => {
	if (forceShow) return true;

	if (country_code !== COUNTRY) return false;
	if (!filters || filters.projects !== true) return false;

	// filtersTags.locations puede venir como objeto suelto o como array, y cada
	// entrada agrupa sus ubicaciones en .value (ver LocationTagsHolder).
	return toArray(filtersTags?.locations).some(location =>
		toArray(location?.value).some(item => isPuntaDelEste(item, locationId))
	);
};
